import React from 'react'
import { MDXTag } from '@mdx-js/tag'


const layoutProps = {};
export default class MDXContent extends React.Component {
  constructor(props) {
    super(props);
    this.layout = null;
  }

  render() {
    const {
      components,
      ...props
    } = this.props;
    return <MDXTag name="wrapper" components={components}><MDXTag name="p" components={components}><MDXTag name="a" components={components} parentName="p" props={{
          "href": "/snippets/main/gatsby-babel/",
          "title": "custom Babel configuration"
        }}>{`A snippet`}</MDXTag>{` with a custom Babel configuration. An `}<MDXTag name="em" components={components} parentName="p">{`import`}</MDXTag>{` plugin is used for both Ant Design and project components`}</MDXTag>
      <MDXTag name="pre" components={components}><MDXTag name="code" components={components} parentName="pre" props={{
          "className": "language-javascript"
        }}>{`// a custom Babel configuration file (.babelrc)
{
    "presets": [
        [ //first specify a gatsby preset
            "babel-preset-gatsby",
            {
                "targets": { // old browsers support
                    "browsers": [">0.25%", "not dead"],
                },
            },
        ],
    ],
    "plugins":[ // short import syntax for Ant Design and project components
        ["import", { "libraryName": "antd", "libraryDirectory": "lib", "style": true}, "ant"],
        ["import", { "libraryName": "actb", "libraryDirectory": "src/components"}, "actb"],
    ]
}
`}</MDXTag></MDXTag>
      <MDXTag name="p" components={components}>{`Similar configuration options were used to support the same import style for both Ant Design and the project itself. Thanks to this, an import of the form `}<MDXTag name="inlineCode" components={components} parentName="p">{`import {Logo} from "actb"`}</MDXTag>{` under the hood is transformed to `}<MDXTag name="inlineCode" components={components} parentName="p">{`import Logo from "actb/src/components/logo"`}</MDXTag>{`, and shorter imports become possible:`}</MDXTag>
      <MDXTag name="pre" components={components}><MDXTag name="code" components={components} parentName="pre" props={{
          "className": "language-javascript"
        }}>{`// succinct import for antd components
import {Button, Icon} from "antd";
// and for project components (assuming an "actb" alias is defined)
import {Mdx, Logo} from "actb";
`}</MDXTag></MDXTag>
           </MDXTag>;
  }

}
export const _frontmatter = {
  "title": "Custom Babel configuration, short import syntax",
  "keywords": "import, Babel, project components, Ant Design",
  "menu": "gatsby/.babelrc"
};
    